import { useNavigate } from "react-router-dom";
import { Screen } from "../components/Screen";

/** Вкладка "Автомобілі" з нижньої навігації — вхід у три каталоги (п.26 ТЗ). */
export function CarsHub() {
  const navigate = useNavigate();
  return (
    <Screen title="Автомобілі">
      <div className="card-list">
        <button className="menu-tile" onClick={() => navigate("/cars/new")}>
          <span className="menu-tile-icon">🚗</span>
          <span className="menu-tile-text">
            <span className="menu-tile-title">Нові Toyota</span>
            <span className="menu-tile-subtitle">Модельний ряд і комплектації</span>
          </span>
        </button>
        <button className="menu-tile" onClick={() => navigate("/cars/inventory")}>
          <span className="menu-tile-icon">📦</span>
          <span className="menu-tile-text">
            <span className="menu-tile-title">Авто в наявності</span>
            <span className="menu-tile-subtitle">Конкретні автомобілі на складі</span>
          </span>
        </button>
        <button className="menu-tile" onClick={() => navigate("/cars/used")}>
          <span className="menu-tile-icon">🔁</span>
          <span className="menu-tile-text">
            <span className="menu-tile-title">Авто з пробігом</span>
            <span className="menu-tile-subtitle">Актуальна пропозиція</span>
          </span>
        </button>
      </div>
    </Screen>
  );
}
